define('views/components/customer_product/customer_product_list',['require','views/base/list_view','views/components/customer_product/customer_product','text!templates/components/customer_product/customer_product_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/customer_product/customer_product');

    var temp = require("text!templates/components/customer_product/customer_product_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

